import { useEffect } from 'react';
import { LoadingSkeleton, TableTitleBox } from '../../common/components';
import GenerationControlFilters from './components/GenerationControlFilters';
import GenerationControlDataTable from './components/GenerationControlDataTable';
import { useGenerationControlTable } from './hooks/useGenerationControl';

const GenerationControlTable = () => {
  const {
    data,
    isLoading,
    filter,
    branches,
    plans,
    groups,
    paymentMethods,
    handleFilter,
    handleSearch,
    initializeDefaultValues,
  } = useGenerationControlTable();

  useEffect(() => {
    initializeDefaultValues();
  }, [initializeDefaultValues]);

  if (isLoading) { return <LoadingSkeleton />; }

  return (
    <>
      <TableTitleBox title="Habitat 99 | Cupones | Control de generación" />

      <GenerationControlFilters
        filter={filter}
        handleFilter={handleFilter}
        onSearch={handleSearch}
        branches={branches}
        plans={plans}
        groups={groups}
        paymentMethods={paymentMethods}
      />

      <GenerationControlDataTable
        data={data}
        isLoading={isLoading}
        LoadingComponent={LoadingSkeleton}
      />
    </>
  );
};

export default GenerationControlTable;
